import { environment } from "../../config";
import {
  DeletedIndicadores,
  EditIndicadorFields,
  iDataIndicador,
  PostIndicadorFields,
} from "../../interfaces/SuperAdmin/Pages/iDataIndicador";

import { fetchData } from "./httpClient";

const { REACT_APP_API_OAS } = environment;
const baseApiBroker = REACT_APP_API_OAS;

export const getIndicadoresByObjId = (id_objetivo: string) =>
  fetchData<iDataIndicador[]>({
    method: "GET",
    url: `${baseApiBroker}/indicador/objetivo/${id_objetivo}`,
  });

export const deleteIndicadores = (data: { ids: string[] }) =>
  fetchData<DeletedIndicadores>({
    method: "DELETE",
    url: `${baseApiBroker}/indicador`,
    data,
  });

export const putIndicadorById = (
  data: EditIndicadorFields,
  id_indicador: string
) =>
  fetchData<iDataIndicador>({
    method: "PUT",
    url: `${baseApiBroker}/indicador/${id_indicador}`,
    data,
  });

export const postIndicador = (data: PostIndicadorFields) =>
  fetchData<iDataIndicador>({
    method: "POST",
    url: `${baseApiBroker}/indicador`,
    data,
  });
